/* eslint-disable no-mixed-spaces-and-tabs */
import { Box, Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import {
	CommunicationSettings,
	EssentialLocationDetails,
	ShiftSettings,
	WorkCenters,
} from "../../../../../../export/gat-admin";
import {
	getAllJobsByLocation,
	getAllShiftAllocationRules,
	getAllTimeZones,
	getLocations,
	// eslint-disable-next-line sort-imports
	getLocationSettings,
	resetCreateNewLocation,
	updateCreateNewLocation,
} from "../../../../../../export/gat-admin";
import BusStops from "../../../../transport/ui/bus-stops";
import { getWorkerNotificationTypes } from "../../../store/gat-admin-slice";
import {
	CompanyLocation,
	GATAdminCompany,
	LocationType,
} from "../../../store/gat-admin-slice-types";
import AddOnSettingsLocation from "../add-on-settings-location";
import LocationLimitsControls from "../sections/limits-controls";


interface ILocationFormPageProps {
	creatingNewLocation: boolean;
	locationData: LocationType;
	createNewLocationStatus: string;
	newLocationId: any;
	companyDataValue: GATAdminCompany;
	locations: CompanyLocation[];
	closeLocationForm: any;
	createNewLocationErrorMessage: any;
}

const LocationFormPage = ({
	creatingNewLocation,
	locationData,
	createNewLocationStatus,
	newLocationId,
	companyDataValue,
	locations,
	closeLocationForm,
	createNewLocationErrorMessage,
}: any) => {
	const dispatch = useDispatch();

	useEffect(() => {
		try {
			dispatch(getAllTimeZones());
			dispatch(getAllShiftAllocationRules());
		} catch (error) {
			// Do nothing
		}
	}, [dispatch]);

	useEffect(() => {
		if (!creatingNewLocation && locationData.id) {
			dispatch(getAllJobsByLocation(locationData.id));
			dispatch(getLocationSettings(locationData.id));
			dispatch(getWorkerNotificationTypes(locationData.id));
		}
	}, [dispatch, creatingNewLocation, locationData]);

	useEffect(() => {
		if (createNewLocationStatus === "fulfilled" && newLocationId) {
			dispatch(getLocationSettings(newLocationId));
			dispatch(getWorkerNotificationTypes(newLocationId));
			dispatch(getAllShiftAllocationRules());
			dispatch(updateCreateNewLocation(false));
		}
	}, [dispatch, createNewLocationStatus, newLocationId, companyDataValue]);

	return (
		<>
		<Box sx={{ pb: 4 }}>
			<EssentialLocationDetails
				locationData={locationData}
				creatingNewLocation={creatingNewLocation}
				closeLocationForm={closeLocationForm}
			/>
			{!creatingNewLocation ? (
				<>
					<LocationLimitsControls
						locationData={locationData}
						companyId={companyDataValue?.id}
					/>

					<WorkCenters
						location={locations.filter(
							(loc: CompanyLocation) => loc.id === locationData.id
						)}
					/>

					<CommunicationSettings
						locationData={locationData}
						creatingNewLocation={creatingNewLocation}
						entity='location'
					/>
					<ShiftSettings
						locationData={
							locations.find(
								(loc: CompanyLocation) => loc.id === locationData.id
							) ?? locationData
						}
						creatingNewLocation={creatingNewLocation}
						entity='location'
					/>

					<AddOnSettingsLocation
                        locationData={locationData}
                        companyDataValue={companyDataValue}
                    />

					<BusStops
						locationId={locationData.id}
						locationName={locationData.name}
					/>
				</>
			) : null}

			{/* <ShiftSettings
					locationData={locationData}
					creatingNewLocation={creatingNewLocation}
					entity='location'
				/> */}
			{/* <WorkerAppSettings entity='location' /> */}

			{/* <AddOnFeatures entity='location' /> */}

			<Snackbar
				open={createNewLocationStatus === "error"}
				autoHideDuration={2000}
				onClose={() => {
					dispatch(resetCreateNewLocation());
				}}
				anchorOrigin={{ vertical: "top", horizontal: "center" }}
			>
				<MuiAlert elevation={6} variant='filled' severity='error'>
					{createNewLocationErrorMessage ??
						"An Error Occurred. Please try again."}
				</MuiAlert>
			</Snackbar>
			<Snackbar
				open={createNewLocationStatus === "fulfilled"}
				autoHideDuration={3000}
				onClose={() => {
					dispatch(resetCreateNewLocation());
					dispatch(getLocations(companyDataValue.id));
				}}
				anchorOrigin={{ vertical: "top", horizontal: "center" }}
			>
				<MuiAlert elevation={6} variant='filled' severity='success'>
					{"New location added!"}
				</MuiAlert>
			</Snackbar>
			</Box>
		</>
	);
};

export default LocationFormPage;
